import u from "fast-levenshtein";
import { filter as c } from "fuzzy";
function y(n, e = (t, i) => t === i) {
  const t = [];
  for (const i of n) {
    let r = !1;
    for (const o of t)
      if (e(i, o)) {
        r = !0;
        break;
      }
    r || t.push(i);
  }
  return t;
}
function w(n, e) {
  const t = new Array(Math.ceil(n.length / e));
  for (let i = 0; i < t.length; i++)
    t[i] = n.slice(i * e, i * e + e);
  return t;
}
function x(n) {
  const e = new Array(Math.max(0, n.length - 1));
  for (let t = 0; t < e.length; t++)
    e[t] = [n[t], n[t + 1]];
  return e;
}
function A(n) {
  return (e, t) => n(t, e);
}
function l(n, e, t) {
  let i = 0;
  for (let r = 0; r < t.length && i === 0; r++)
    i = t[r](n, e);
  return i;
}
function M(n) {
  return (e, t) => l(e, t, n);
}
function f(n, e, t = "asc") {
  const i = t === "asc" ? 1 : -1;
  return n < e || n == null && e != null ? -1 * i : n > e || n != null && e == null ? 1 * i : 0;
}
function a(n, e = "asc") {
  return (t, i) => f(t[n], i[n], e);
}
function F(n, e) {
  let t = 0, i = e(n[0], 0);
  for (let r = 1; r < n.length; r++) {
    const o = e(n[r], r);
    o > i && (t = r, i = o);
  }
  return t;
}
function I(n, e) {
  let t = [0], i = e(n[0], 0);
  for (let r = 1; r < n.length; r++) {
    const o = e(n[r], r);
    o > i ? (t = [r], i = o) : o === i && t.push(r);
  }
  return t;
}
function S(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t], t, n))
      return n[t];
}
function p(n, e) {
  const t = [];
  for (let i = 0; i < n.length; i++)
    e(n[i], i, n) && t.push(n[i]);
  return t;
}
function b(n) {
  return Array.isArray(n) ? n : [n];
}
function v(n, e, t) {
  if (e < 0 || e >= n.length || t < 0 || t >= n.length)
    throw new RangeError(
      `invalid from/to specified. Array has a length of ${n.length}, from is ${e} and to is ${t}`
    );
  if (e === t)
    return n;
  const i = n[e], r = Math.abs(t - e), o = Math.sign(t - e);
  for (let s = 0; s < r; s++)
    n[e + s * o] = n[e + s * o + o];
  return n[t] = i, n;
}
function E(n, e, t) {
  const i = Array.from(n), r = i.findIndex((o) => t(o) === e);
  return r !== -1 && i.splice(r, 1), i;
}
function B(n, e, t) {
  const i = Array.from(n), r = t(e), o = i.findIndex((s) => t(s) === r);
  return o !== -1 && (i[o] = e), i;
}
function L(n, e, t) {
  const i = e.toLowerCase();
  return n.map((r) => ({
    item: r,
    score: (t(r).toLowerCase().includes(i) ? Number.MAX_SAFE_INTEGER : 0) - u.get(t(r).toLowerCase(), i)
  })).sort(a("score", "desc")).map(({ item: r }) => r);
}
function D(n, e, t) {
  return c(e, n, {
    extract: t
  }).sort(a("score", "desc")).map(({ original: i }) => i);
}
function R(n, e) {
  return e[n]();
}
function q(n) {
  return () => n();
}
function C(n) {
  return (...e) => {
    (async () => {
      await n(...e);
    })().catch(console.warn);
  };
}
const N = {
  origin: { x: 0, y: 0 },
  add(n, e) {
    return {
      x: n.x + e.x,
      y: n.y + e.y
    };
  },
  distance(n, e) {
    return Math.sqrt((n.x - e.x) ** 2 + (n.y - e.y) ** 2);
  }
};
function T(n, e, t) {
  return Math.min(Math.max(n, e), t);
}
function $(n, e, t, i, r) {
  return (n - e) / (t - e) * (r - i) + i;
}
function z(n, e, t) {
  return n * (t - e) + e;
}
function d(n) {
  const e = n.toString(), t = e.indexOf(".");
  return t === -1 ? 0 : e.length - t - 1;
}
function h(n, e) {
  return Math.round(n * 10 ** e) / 10 ** e;
}
function V(n, e, t) {
  let i = n;
  return t?.mode === "floor" ? i += t.ceilFloorNudge ?? 0 : t?.mode === "ceil" && (i -= t.ceilFloorNudge ?? 0), h(
    Math[t?.mode ?? "round"](i / e) * e,
    d(e)
  );
}
function _(n, e, t) {
  return n >= e && n <= t;
}
const O = (...n) => {
};
async function P(n, e) {
  e?.signal?.throwIfAborted(), await new Promise((t, i) => {
    const r = () => {
      o && (clearTimeout(o), i(e?.signal?.reason));
    };
    e?.signal?.addEventListener("abort", r, { once: !0 });
    let o = setTimeout(() => {
      o = null, e?.signal?.removeEventListener("abort", r), t();
    }, n);
  });
}
async function j(n) {
  return n?.signal?.throwIfAborted(), await new Promise((e, t) => {
    const i = () => {
      r && (cancelAnimationFrame(r), t(n?.signal?.reason));
    };
    n?.signal?.addEventListener("abort", i, { once: !0 });
    let r = requestAnimationFrame((o) => {
      r = null, n?.signal?.removeEventListener("abort", i), e(o);
    });
  });
}
export {
  V as A,
  _ as B,
  O as C,
  P as D,
  j as E,
  N as V,
  x as a,
  M as b,
  w as c,
  y as d,
  f as e,
  a as f,
  F as g,
  I as h,
  A as i,
  S as j,
  p as k,
  b as l,
  l as m,
  v as n,
  B as o,
  L as p,
  D as q,
  E as r,
  R as s,
  q as t,
  C as u,
  T as v,
  $ as w,
  z as x,
  d as y,
  h as z
};
//# sourceMappingURL=timing-BFaISC6B.js.map
